import React from 'react';
import propTypes from 'prop-types';

import Panel from '../Panel/Panel';
import Header from '../Header/Header';
import TextDisplay from '../TextDisplay/TextDisplay';

import './Standard.css';

const Standard = props =>
  (
    <section className={`standard ${props.data.fullscreen ? 'fullscreen' : ''} ${props.data.style}`}>
      {
        props.data.video &&
        <video className={"standard__video "+props.data.style} loop={props.data.video.loop} autoPlay style={{ objectFit: props.data.video.fit }}>
          <source src={props.data.video.src} type="video/mp4" />
        </video>
      }
      {
        props.data.background &&
        <img
          className={`background__image ${props.data.background.fit}`}
          src={props.data.background.src}
          alt={props.data.background.alt}
        />
      }
      <section className={`standard__lhs ${props.data.style ? props.data.style : ''}`}>
        {
          (props.data.title || props.data.subtitle || props.data.pretitle) &&
          <Header
            title={props.data.title}
            subtitle={props.data.subtitle}
            pretitle={props.data.pretitle}
          />
        }
        <Panel />
      </section>
      <section className={`standard__rhs ${props.data.style ? props.data.style : ''}`}>
        {
          props.data.image && props.data.image.edgeoverlay &&
          <section className="standard__image-overlay"></section>
        }
        {
          props.data.image &&
          <img
            className={`standard__image ${props.data.image.fit}`}
            src={props.data.image.src}
            alt={props.data.image.alt}
          />
        }
        {
          props.data.textDisplay &&
          <TextDisplay data={props.data.textDisplay} />
        }
        {
          props.data.altPanel > -1 &&
          <Panel panel={props.data.altPanel} />
        }
      </section>
      {
        (props.data.altVideo) &&
        <section className={`standard__altMediaArea ${props.data.style}`}>
          {
            props.data.altVideo &&
            <video className="standard__video" loop={props.data.altVideo.loop} autoPlay style={{ objectFit: props.data.altVideo.fit }}>
              <source src={props.data.altVideo.src} type="video/mp4" />
            </video>
          }
        </section>
      }
      {
        props.data.altImage &&
        <img
          className={`standard__altImage ${props.data.altImage.fit ? props.data.altImage.fit : ''}`}
          src={props.data.altImage.src}
          alt={props.data.altImage.alt}
        />
      }
    </section>
  );

Standard.propTypes = {
  data: propTypes.shape({
    title: propTypes.string,
    subtitle: propTypes.string,
    pretitle: propTypes.string,
    image: propTypes.object,
    altImage: propTypes.object,
    video: propTypes.object,
    fullscreen: propTypes.bool,
    altVideo: propTypes.object,
    style: propTypes.string,
  }),
};

export default Standard;



// WEBPACK FOOTER //
// ./src/components/Standard/Standard.js